import React from "react";
import cn from "classnames";

import { RegularText } from "components/Text";

import styles from "./styles.module.scss";

export const Radio = ({ id, name, label, checked, onChange, className }) => (
  <label htmlFor={id} className={cn(styles.radioLabel, className)}>
    <input
      className={styles.radioInput}
      type="radio"
      name={name}
      id={id}
      onChange={onChange}
      checked={checked}
    />
    <span className={styles.customRadio} />
    <RegularText size={13}>{label}</RegularText>
  </label>
);
